import LoggedInDetailPage from './LoggedInDetailPage.container'

export default LoggedInDetailPage
